import apiClient from "@shared/services/apiClient";
import type { TenantNotificationBanner } from "@shared/types/tenantNotificationBanner";

export async function fetchActiveTenantNotificationBanner(
  orgId: string,
): Promise<TenantNotificationBanner | null> {
  const response = await apiClient.get(
    `/organizations/${encodeURIComponent(orgId)}/notification-banner/active`,
  );
  const envelope = response?.data;
  const payload =
    envelope && typeof envelope === "object" && "data" in envelope
      ? (envelope as { data: unknown }).data
      : envelope;

  if (!payload || typeof payload !== "object") {
    return null;
  }

  const banner = payload as TenantNotificationBanner;
  if (!banner.banner_id || !banner.message) {
    return null;
  }

  return banner;
}
